import { Component, OnInit, ViewChild, Output, EventEmitter, Input} from '@angular/core';
import { Department } from './department.model';
import { UserManagmentService } from '../../user-managment.service';
import { ErrorHandler } from '@root/utils/error-handler.service';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.scss'],
  providers: [UserManagmentService]
})
export class DepartmentComponent implements OnInit {

  @ViewChild('f', { static: false }) form: NgForm;

  @Input() regionList = [];

  @Input() department: Department;

  @Output() refresh = new EventEmitter();

  departmentList = [];

  constructor(public userManagmentService: UserManagmentService,
              private toastr: ToastrService,
              private errorHandler: ErrorHandler) { }


  ngOnInit() {
   //
  }

   /***
   * Special Character validation
   */
  keyPressAlpha(event: any) {
    const pattern = /[a-zA-Z0-9 ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  public processDepartment(){
    this.userManagmentService.createOrUpdateDepartment(this.department).subscribe(
      response => {
        if(response.status === 0){
          this.toastr.success(response.message);
          this.refresh.emit();
          this.resetForm();
        }else{
          this.errorHandler.handleError(response);
        }

      },
      error => {
        this.errorHandler.handleError(error);
      }
    )
  }

  resetForm(){
    this.form.resetForm();
  }
}
